import { render, staticRenderFns } from "./login1.vue?vue&type=template&id=4fd895b0&scoped=true&"
import script from "./login1.vue?vue&type=script&lang=js&"
export * from "./login1.vue?vue&type=script&lang=js&"
import style0 from "./login1.vue?vue&type=style&index=0&id=4fd895b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd895b0",
  null
  
)

export default component.exports